import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SingleWebhookComponent } from './single-webhook.component';
import { DashboardModule } from '../dashboard/dashboard.module';
import { ButtonFillModule } from 'src/app/common/utilities/buttons/button-fill/button-fill/button-fill.module';
import { TableModule } from "../../common/utilities/table/table.module";
import { CopyTextModule } from "../../common/utilities/copy-text/copy-text.module";
import { ModalModule } from 'src/app/common/components/modal/modal.module';
import { InputModule } from 'src/app/common/utilities/input/input/input.module';
import { DropdownModule } from 'src/app/common/utilities/dropdown/dropdown.module';
import { ButtonOutlineModule } from 'src/app/common/utilities/buttons/button-outline/button-outline/button-outline.module';
import { ToastModule } from 'primeng/toast';
import { CopyTextSingleLineModule } from 'src/app/common/utilities/copy-text-single-line/copy-text-single-line.module';
import { FilterModule } from "../../common/components/filter/filter.module";
import { PaginationModule } from "../../common/components/pagination/pagination.module";
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { RequestTableModule } from 'src/app/common/components/request-table/request-table.module';


@NgModule({
    declarations: [
        SingleWebhookComponent
    ],
    imports: [
        CommonModule,
        DashboardModule,
        ButtonFillModule,
        TableModule,
        CopyTextModule,
        ModalModule,
        InputModule,
        DropdownModule,
        ButtonOutlineModule,
        ToastModule,
        CopyTextSingleLineModule,
        FilterModule,
        PaginationModule,
        NgxJsonViewerModule,
        RequestTableModule
    ]
})
export class SingleWebhookModule { }
